<div class="modal-dialog modal-lg" role="document">
  <div class="modal-content">
    <div class="modal-header">
      <div class="modal-title" i18n>Multi Calendar</div>
      <a (click)="close()" class="cstm-close">
        <span class="far fa-times"></span>
      </a>
    </div>
    <div class="modal-body">
      <app-calendar-multi></app-calendar-multi>
    </div>
  </div>
</div>
